import React from 'react'
import { useState } from 'react';

import Inputs from './InputsComponent';
import Resultados from './ResultadosComponent';

const InputAResultado = ({ closeModal, data }) => {
  
  const [verResultados, setVerResultados] = useState(false);

  // const [totales, setTotales] = useState(0)

  
  function showResultados(){
    setVerResultados(true);
  }


  function volver(){
    setVerResultados(false);
  }


  // function handleValores() {
  //   setTotales()
  // }


  if (!verResultados) {
    return <Inputs 
            onClick={showResultados} 
            data={data} 
            />;
  } else {
    return <Resultados 
            onClick={volver}
            />;
  }
};

export default InputAResultado
